import classNames from "classnames";
import React from "react";
import { useSlate } from "slate-react";
import { DropdownMenuButton } from "./Buttons/Dropdown";
import FixedMenuButton from "./FixedMenuButton";
import { fromHtml } from "./html";
import {
  type RichEditorToolbarButton,
  type RichEditorToolbarButtonOnClickAction,
  type RichEditorToolbarButtons,
  type RichEditorToolbarFixedButton,
  type RichEditorToolbarMenu
} from "./types";

type ButtonProps = {
  button: RichEditorToolbarFixedButton | RichEditorToolbarMenu | RichEditorToolbarButton;
  dropdownClassName?: string;
};
const Button = (props: ButtonProps) => {
  const editor = useSlate();

  const onAction = React.useCallback((action: RichEditorToolbarButtonOnClickAction) => {
    switch (action.action) {
      case "paste": {
        editor.insertFragment(fromHtml(action.content));
        break;
      }
    }
  }, []);

  if (typeof props.button === "string") {
    return <FixedMenuButton dropdownClassName={props.dropdownClassName} format={props.button} />;
  }

  if ("items" in props.button) {
    return <DropdownMenuButton dropdownClassName={props.dropdownClassName} menu={props.button} />;
  }

  return <props.button onClick={onAction} />;
};

type ContentProps = {
  dropdownClassName?: string;
  menu: RichEditorToolbarButtons;
  shouldGroup?: boolean;
};
const Content = (props: ContentProps) => (
  <>
    {props.menu.map((x, i) => {
      if (Array.isArray(x)) {
        return (
          <div key={`group-${i}`} className="group">
            <Content dropdownClassName={props.dropdownClassName} menu={x} shouldGroup={false} />
          </div>
        );
      }

      return props.shouldGroup ? (
        <div key={`group-${i}`} className="group">
          <Button button={x} dropdownClassName={props.dropdownClassName} />
        </div>
      ) : (
        <Button key={i} button={x} dropdownClassName={props.dropdownClassName} />
      );
    })}
  </>
);

type Props = {
  className?: string;
  dropdownClassName?: string;
  isDisabled?: boolean;
  menu: RichEditorToolbarButtons;
  style?: React.CSSProperties;
};
const Menu = React.forwardRef(
  ({ className, dropdownClassName, menu, ...props }: Props, ref: React.RefObject<HTMLDivElement>) => (
    <div {...props} ref={ref} className={classNames(className, "rich_editor_menu", { disabled: props.isDisabled })}>
      <Content dropdownClassName={dropdownClassName} menu={menu} shouldGroup />
    </div>
  )
);
export default Menu;
